<script>
// import { onMount } from 'svelte';
import Icon from 'fa-svelte';
import { faGithub, faLinkedin, faSith, faStackOverflow, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLemon } from '@fortawesome/free-solid-svg-icons';

let section = 'intro';

// onMount(async () => {
//   let el = document.querySelector('.wrapper-inner');
//   console.log(el);
//   SimpleScrollbar.initEl(el);
// });
</script>

<div class="wrapper" >
  <div class="wrapper-inner">
    <header>

      <div class="avatar mb-2">
        <img class="w-full" src="img/paris.png" srcset="img/paris_2x.png 336w, img/paris.png 168w" sizes="168px" width="168" height="168" alt="avatar">
        <!-- <img class="w-full" src="http://placehold.it/168.png/22a?text=JOEL" srcset="http://placehold.it/336.png/22a?text=JOEL 336w, http://placehold.it/168.png/22a?text=JOEL 168w" sizes="168px" width="168" height="168" alt="avatar"> -->
      </div>

      <div class="name">
        <h1 class="uppercase text-white">Nic Sandfield</h1>
        <span class="text-gray-600 text-sm">Data-Analyst/Developer</span>
      </div>

      <div class="social">
        <ul>
          <li class="inline-block pr-2"><a aria-label="Github" href="https://github.com/niczero"><Icon icon={faGithub} aria-hidden="true"></Icon></a></li>
          <li class="inline-block pr-2"><a aria-label="CPAN" href="https://metacpan.org/author/NICZERO"><Icon icon={faSith} aria-hidden="true"></Icon></a></li>
          <li class="inline-block pr-2"><a aria-label="LinkedIn" href="https://uk.linkedin.com/in/niczero"><Icon icon={faLinkedin} aria-hidden="true"> </Icon></a></li>
          <li class="inline-block pr-2"><a aria-label="StackOverflow" href="https://stackoverflow.com/users/891516/niczero"><Icon icon={faStackOverflow} aria-hidden="true"></Icon></a></li>
          <li class="inline-block pr-2"><a aria-label="Twitter" href="https://twitter.com/nic_sandfield"><Icon icon={faTwitter}></Icon></a></li>
        </ul>
      </div>

      <nav class="mt-8">
        <ul class="text-xs">
          <li><a class:active="{section === 'intro'}" on:click="{() => section = 'intro'}" href="#intro">Intro</a></li>
          <li><a class:active="{section === 'perl'}" on:click="{() => section = 'perl'}" href="#perl">Perl</a></li>
          <li><a class:active="{section === 'mysql'}" on:click="{() => section = 'mysql'}" href="#mysql">MySQL</a></li>
          <li><a class:active="{section === 'git'}" on:click="{() => section = 'git'}" href="#git">Git</a></li>
          <li><a class:active="{section === 'recipe'}" on:click="{() => section = 'recipe'}" href="#recipe">Recipe</a></li>
          <li><a class:active="{section === 'contact'}" on:click="{() => section = 'contact'}" href="#contact">Contact</a></li>
        </ul>
      </nav>

      <div class="copyright mt-20 text-xs">
        <!-- <span>© 2019 Nic Sandfield</span> -->
      </div>
    </header>

    <main>

      <section id="intro">

        <div class="section-header">
          <h2>Introduction</h2>
        </div>
        <div>
          <p>Here is a brief overview of my main OSS projects. I try to use
          permissive (eg MIT) licensing where I can (but check each project
          for specifics). Since becoming a parent, my time for opensource
          development is rationed to focused bursts, so the documentation
          never quite keeps up. I will endeavour to write some articles to
          provide a more welcoming introduction; some of these packages
          represent weeks of work and most are being used in production
          environments.</p>
        </div>
      </section>

      <section id="perl">

        <div class="section-header">
          <h2>Perl</h2>
        </div>
        <div>
          <ul>
            <li><a href="https://github.com/niczero/mojar"
            class="font-normal">Mojar</a> is my namespace for utilities,
            modules, and agents to extend the Mojolicious platform for
            accessing additional (eg non-web) uses or third-party
            interfaces.</li>

            <li>If you are not yet using a connector-based accessor for
            MySQL, take a look at <a
            href="https://github.com/niczero/mojar-mysql"
            class="font-normal">Mojar::Mysql</a>. The <a
            href="https://metacpan.org/pod/Mojar::Mysql::Connector"
            class="font-normal">::Connector</a> module provides a reusable
            connector (a database handle builder) and several distinctive
            conveniences, in particular support for using external
            configuration files for storing your database credentials and
            connection parameters. This alone can make testing and automated
            monitoring much easier and reliable. The package also includes
            DBA power tools, for example for monitoring and repairing
            replication.</li>

            <li>If you are looking for an API to reliably batch-download your
            Google Analytics data, for instance to import into a
            datawarehouse, <strong>Mojar::Google::Analytics</strong> is your friend.</li>
          </ul>
        </div>
      </section>

      <section id="mysql">

        <div class="section-header">
          <h2>MySQL</h2>
        </div>

        <div>
          <ul>
            <li><a href="https://github.com/niczero/mojar-mysql"
            class="font-normal">Mojar::Mysql</a> is your box of Perl
            powertools for accessing, monitoring, repairing, and controlling
            MySQL instances, from v4.0 to v8.0.</li>

            <li>By supporting the use of <code>.cnf</code> accessor files,
            the <a href="https://metacpan.org/pod/Mojar::Mysql::Connector"
            class="font-normal">::Connector</a> module lets your Perl code
            (Mojolicious apps, Zabbix agents, RT instances, CheckMk scripts,
            &#8230) utilise the same accessors as your bash scripts, MySQL
            tools, and commandline testing.</li>

            <li>The <a href="https://metacpan.org/pod/Mojar::Mysql::Replication"
            class="font-normal">::Replication</a> module facilitates
            monitoring and repairing replication.</li>

            <li>The <a href="https://metacpan.org/pod/Mojar::Mysql::Util"
            class="font-normal">::Util</a> module contains the marvellous
            <span class="font-normal">quiesce</span> method, which makes it
            possible for your server domain to take reliable (backup)
            snapshots with all the MySQL cogs suspended.</li>

            <li>If you apply my <a
            href="https://bugs.mysql.com/bug.php?id=75425"
            class="font-normal">MySQL patch</a> to v5.6 source code then your
            (Perl, Python, PHP, &#8230) code can access any version of MySQL
            from v4.0 to v8.0. I believe this is the only means to achieve
            that goal.</li>
          </ul>

        </div>

      </section>

      <section id="git">

        <div class="section-header">
          <h2>Git</h2>
        </div>

        <div>
          <ul>
            <li><a href="https://github.com/niczero/git-transplant"
            class="font-normal">git-transplant</a> can be very convenient when
            you want to rewrite local Git commits, for example when you need
            to reinstate timestamps, remove an erroneous file, or collapse an
            experimental branch into something cleaner.</li>

            <li><a href="https://github.com/niczero/daggit"
            class="font-normal">daggit</a> is a javascript module for
            rendering Git history into a beautiful colour-coded graph. This
            will be incorporated into the forthcoming
            <strong>git-surveillance</strong> which makes it easier to
            understand and re-work complex Git trees.</li>
          </ul>
        </div>

      </section>

      <section id="recipe">

        <div class="section-header">
          <h2>Recipe</h2>
        </div>
        <p class="mb-8">Finally, it's always good to finish with a recipe.</p>

        <div class="recipe">
          <h3 class="mb-2">High-Protein Pancakes</h3>
          <div class="description">
            <p>This recipe was invented to provide extra protein for a child
            with a restricted diet. These have a high egg content, so eat them
            fresh rather than store them! Proportions here provide a meal for
            two hungry children; perhaps if you divide by 3 it would suit a
            pre-school child or a snack for someone older.</p>
          </div>
          <div class="ingredients">
            <ol>
              <li>180g plain flour (bread flour is even better)</li>
              <li>45ml sugar</li>
              <li>6ml baking powder</li>
              <li>3ml salt</li>
              <li>3 eggs</li>
              <li>150ml milk</li>
            </ol>
          </div>
          <div class="directions">
            <ol>
              <li>Sift the dry ingredients into a large bowl.</li>
              <li>With a strong fork, stir in the eggs.</li>
              <li>Little by little, stir in the milk, avoiding the creation
              of lumps.</li>
              <li>Leave it on the side for 5 minutes while you gently warm
              (on a low heat) some oil in your pan. Dry away all the oil just
              before the first pancake.</li>
              <li>As soon as the edges are solid enough, turn the pancake
              over; don't wait for the top to cook dry.</li>
              <li>Serve with a moist topping, for example chopped fruits in
              yoghurt.</li>
            </ol>
          </div>
        </div>
      </section>

      <section id="contact" class="contact">

        <div class="section-header">
          <h2>Get In Touch</h2>
        </div>

        <div class="item flex">
          <div class="thumb flex-initial mb-8">
            <img src="img/code.jpg" srcset="img/code_2x.jpg 360w, img/code.jpg 180w" sizes="180px" width="180" height="80" alt="code">
          </div>
          <div class="text flex-1 ml-8 mb-8">
            <p>For feedback relating to CPAN or Github code, the best channel
            is the 'issues' link for the particular module.</p>
          </div>
        </div>

        <div class="item flex">
          <div class="thumb flex-initial mb-8">
            <img src="img/chat.jpg" srcset="img/chat_2x.jpg 360w, img/chat.jpg 180w" sizes="180px" width="180" height="80" alt="IRC">
          </div>
          <div class="text flex-1 ml-8 mb-8">
            <p>I am often around on the <a
            href="https://kiwiirc.com/nextclient/#irc://irc.freenode.net/mojo?nick=visitor-?">Mojolicious
            channel</a> in IRC.</p>
          </div>
        </div>

        <div class="item flex">
          <div class="thumb flex-initial mb-8">
            <img src="img/hire.jpg" srcset="img/hire_2x.jpg 360w, img/hire.jpg 180w" sizes="180px" width="180" height="80" alt="LinkedIn">
          </div>
          <div class="text flex-1 ml-8 mb-8">
            <p>Recruiters might be able to reach me via LinkedIn.</p>
          </div>
        </div>

      </section>

      <section id="credits" class="credits">

        <div class="section-header">
          <h2>Acknowledgements</h2>
        </div>

        <div class="text">
          <p>This page was implemented using <a href="https://svelte.dev">SvelteJS</a> and <a
          href="https://tailwindcss.com">TailwindCSS</a> based on a design licensed from <a
          href="https://themeforest.net/user/pxlsolutions/portfolio">PxlSolutions</a>.</p>
        </div>

        <div class="text">
          <p>Stock photos by
          <a href="https://unsplash.com/@markusspiske?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Markus Spiske</a>,
          <a href="https://unsplash.com/@room?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">ROOM</a>,
          and
          <a href="https://unsplash.com/@clemono2?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Clem Onojeghuo</a>
          on
          <a href="https://unsplash.com?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>.</p>
        </div>
      </section>
    </main>
  </div>
</div>
